import Conversion from "./Conversion";

export default class JobThumbnails {
    small = [];
    preview = [];
    small_enabled = true;

    constructor() {
    }
}